const useModifiedUrl = (path: string): string => {
  const hasUcdeInPath = window.location.pathname.includes('/ucde');

  return hasUcdeInPath ? path : path.replace('/ucde/', '');
};

export default useModifiedUrl;
